<template>
  <button @click.stop.prevent="click()" class="cursor-pointer py-2 w-full h-full absolute inset-0 text-gray-400 hover:text-bc-blue">
    <aw-icon
      icon="plus"
      class="relative w-4 h-4 "
    ></aw-icon>
  </button>
  <!-- <aw-icon
    title="add color row"
    icon="table-col"
    class="
      w-4
      h-4
      cursor-pointer
      mr-0
      text-gray-400
      hover:text-gray-500
      
    "
    @click.stop.prevent="click()"
  ></aw-icon> -->
</template>

<script>
import BaseAddElement from '../../../mixins/BaseAddElement'
export default {
  mixins: [BaseAddElement],
  methods: {
    click() {
      this.parent.data.headers.push(this.$t('Header'))
      this.parent.metaData = { newColIndex: this.parent.data.headers.length }
      for (let index = 0; index < this.parent.children.length; index++) {
        this.parent.children[index].data.cols.push(this.$t('Col value'))
      }
      this.parent.updated = 'headers'
    }
  }
}
</script>
